import { HttpErrorResponse } from '@angular/common/http';
import { ITagDTO, ITagUsageDTO } from '@modeso/types__aumico-lib-companies-be';
import { Observable } from 'rxjs';

/** REV-22155 — what the pages (persons + companies) may do with the tags store. */
export interface ITagsProvider {
    dispatchTagsList(): void;
    dispatchCreateTag(name: string): void;
    dispatchTagUsage(id: string): void;
    dispatchClearTagUsage(): void;
    dispatchDeleteTag(id: string): void;
    resetTagsErrors(): void;

    getTags$(): Observable<ITagDTO[]>;
    getTagNamesById$(): Observable<Record<string, string>>;
    getTagUsage$(): Observable<{ id: string; usage: ITagUsageDTO } | null>;
    getTagsError$(): Observable<HttpErrorResponse | null>;
}
